var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"team-home"}},[_c('PageTitle',{attrs:{"title":_vm.$t('common.home')}}),_c('div',{staticClass:"select-board-placeholder"},[_vm._v(_vm._s(_vm.$t('board.selectPlaceholder')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }